var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input",
      class: { control: true, "input--has-error": _vm.errors.has("last-name") }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.lastNameValue,
            expression: "lastNameValue"
          },
          {
            name: "validate",
            rawName: "v-validate",
            value: { required: true, min: 2 },
            expression: "{required:true, min:2}"
          }
        ],
        staticClass: "input__line",
        attrs: {
          placeholder: _vm.placeholder,
          type: "text",
          name: "last-name",
          id: "last-name"
        },
        domProps: { value: _vm.lastNameValue },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.lastNameValue = $event.target.value
            },
            _vm.updateLastNameData
          ]
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("last-name"),
              expression: "errors.has('last-name')"
            }
          ],
          staticClass: "input__error"
        },
        [_vm._v(_vm._s(_vm.$i18n.t(_vm.errors.first("last-name"))))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b5aea10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b5aea10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/inputs/lastName/lastName.html
// module id = null
// module chunks = 